import type {CardLayout} from '../../../../types/types.ts';

export const firstCardLayouts: Record<string, CardLayout[]> = {
	'1': ['no-body-text', 'no-body-text--alt'],
	'2': [
		'header-elements-on-image',
		'header-elements-on-image--bottom-right',
		'header-elements-on-image--top-right',
		'header-elements-on-image--top-left'
	],
	'3': ['commentary'],
	'4': ['1col-text-2col-image', '2col-image-1col-text']
};

export const firstCardLayoutsPressflow: Record<string, CardLayout[]> = {
	'1': ['pressflow-L', 'pressflow-image-left', 'pressflow-image-right', 'pressflow-compact-inline'],
	'2': ['pressflow-header-overlay-left', 'pressflow-header-overlay-top', 'pressflow-reverse-L-image-overlay'],
	'3': ['pressflow-hero-centered', 'pressflow-image-top'],
	'4': ['pressflow-cover-header-on-image']
};

export const firstCardLayoutsPressflowMobile: Record<string, CardLayout[]> = {
	'1': ['pressflow-mobile-header-square'],
	'2': ['pressflow-mobile-header-portrait'],
	'3': ['pressflow-mobile-full']
};

export const otherCardsLayouts: Record<string, CardLayout[]> = {
	'1': ['1col-text-2col-image', '2col-image-1col-text'],
	'2': ['1col-text-on-image-left', '1col-text-on-image-right', '3col-text-on-image-bottom'],
	'3': ['dark'],
	'4': ['no-text']
};

export const imageCardLayouts: Record<string, CardLayout[]> = {
	'1': ['text-on-image'],
	'2': ['contain', 'contain-dark'],
	'3': ['dark']
};

export function getAvailableLayoutsForCard(
	cardNumber: number,
	mode: string,
	isMobile: boolean,
	cardChars: number,
	figureCount: number
): Record<string, CardLayout[]> {
	if (figureCount === 0) {
		return {};
	}

	if (mode === 'pressflow') {
		if (cardNumber === 1) {
			return isMobile ? firstCardLayoutsPressflowMobile : firstCardLayoutsPressflow;
		}

		return {};
	}

	if (cardNumber === 1) {
		return firstCardLayouts;
	}

	if (cardChars === 0 && figureCount > 0) {
		return imageCardLayouts;
	}

	return otherCardsLayouts;
}
